var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalAFY, Positon, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { FormControl, InputLabel, MenuItem as MuiMenuItem, Select, } from "@mui/material";
import React from "react";
export var ModalUpdateQuote = function (props) {
    return (_jsx(ModalAFY, __assign({ openModal: props.openModalUpdate, onClose: props.onUpdateCancel, minWidthModal: "400px", title: "Confirmaci\u00F3n", positionButton: Positon.End, backgroundColorBackdrop: "#676767d1", backgroundColor: "#FFFFFF", name: "", buttonCancel: {
            label: "Cancelar",
            variant: variants.text,
        }, onSave: props.onUpdateConfirm, buttonAdd: {
            label: "Aceptar",
            variant: variants.contained,
        } }, { children: _jsx("div", __assign({ style: { padding: "20px" } }, { children: _jsxs("div", __assign({ style: { marginBottom: "10px" } }, { children: [_jsx("label", __assign({ style: {
                            display: "block",
                            marginBottom: "5px",
                            fontWeight: "bold",
                        } }, { children: "Seleccione el estado de la cotizaci\u00F3n:" })), _jsxs(FormControl, __assign({ fullWidth: true, size: "small", variant: "outlined", style: { marginTop: "8px" } }, { children: [_jsx(InputLabel, __assign({ id: "quote-status-select-label" }, { children: "Estado" })), _jsx(Select, __assign({ labelId: "quote-status-select-label", id: "quote-status-select", value: props.selectedQuoteStatus, label: "Estado", onChange: props.handleStatusChange }, { children: props.statusOptions.map(function (option) { return (_jsx(MuiMenuItem, __assign({ value: option.value || option.id }, { children: option.name }), option.value || option.id)); }) }))] }))] })) })) })));
};
